import { render, staticRenderFns } from "./ShiftReport.vue?vue&type=template&id=6f3bf30f&scoped=true&"
import script from "./ShiftReport.vue?vue&type=script&lang=js&"
export * from "./ShiftReport.vue?vue&type=script&lang=js&"
import style0 from "./ShiftReport.vue?vue&type=style&index=0&id=6f3bf30f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3bf30f",
  null
  
)

export default component.exports